
export default function OneColLayout({ content }) {
  return (
    <div className="w-full flex ">
      {/* Left Column - 70% */}
      <div className="w-full min-h-[200px] rounded-[15px] overflow-hidden">
        {content}
      </div>
    </div>
  );
}
